<app-sidebar>
  <div class="campaigns-page">
    <div class="page-header">
      <h1>Campaigns</h1>
      <button mat-raised-button color="primary" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        New Campaign
      </button>
    </div>

    <div *ngIf="loading" class="campaigns-loading-state">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading campaigns...</p>
    </div>

    <div class="campaigns-empty-state" *ngIf="!loading && dataSource.data.length === 0">
      <mat-icon>campaign</mat-icon>
      <p>No campaigns yet. Create one to generate a shareable trial signup link.</p>
      <p class="campaigns-empty-hint">Select the "New Campaign" button top right.</p>
    </div>

    <div class="campaigns-card" *ngIf="!loading && dataSource.data.length > 0">
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let campaign">{{ campaign.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let campaign">
            <mat-chip [color]="campaign.status === 'ACTIVE' ? 'primary' : 'accent'">
              {{ campaign.status === 'ACTIVE' ? 'Active' : 'Paused' }}
            </mat-chip>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="maxUsers">
          <mat-header-cell *matHeaderCellDef>Max users</mat-header-cell>
          <mat-cell *matCellDef="let campaign">{{ campaign.maxUsers }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="users">
          <mat-header-cell *matHeaderCellDef>Users</mat-header-cell>
          <mat-cell *matCellDef="let campaign">{{ campaign.stats?.approved ?? 0 }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="expiresAt">
          <mat-header-cell *matHeaderCellDef>Expires</mat-header-cell>
          <mat-cell *matCellDef="let campaign">{{ formatDate(campaign.expiresAt) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
          <mat-cell *matCellDef="let campaign">{{ formatDate(campaign.createdAt) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let campaign" class="action-cell">
            <button
              mat-icon-button
              type="button"
              [matMenuTriggerFor]="campaignActionsMenu"
              [matMenuTriggerData]="{ campaign: campaign }"
              matTooltip="Campaign actions"
              aria-label="Open campaign actions menu">
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-menu #campaignActionsMenu="matMenu">
          <ng-template matMenuContent let-campaign="campaign">
            <button mat-menu-item type="button" (click)="copyCampaignUrl(campaign)">
              <mat-icon>content_copy</mat-icon>
              <span>Copy campaign URL</span>
            </button>
            <button mat-menu-item type="button" (click)="openEditDialog(campaign)">
              <mat-icon>edit</mat-icon>
              <span>Edit campaign</span>
            </button>
            <button mat-menu-item type="button" (click)="togglePause(campaign)">
              <mat-icon>{{ campaign.status === 'ACTIVE' ? 'pause_circle' : 'play_circle' }}</mat-icon>
              <span>{{ campaign.status === 'ACTIVE' ? 'Pause campaign' : 'Resume campaign' }}</span>
            </button>
            <button mat-menu-item type="button" (click)="deleteCampaign(campaign)">
              <mat-icon color="warn">delete</mat-icon>
              <span>Delete campaign</span>
            </button>
          </ng-template>
        </mat-menu>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
  </div>
</app-sidebar>
